export type IFormatTime = (
  format: string,
  time: { hour: number; minute: number; second: number; ampm: string; timezone: string },
  ampm: boolean
) => string;

export function formatTime(
  format: string,
  time: { hour: number; minute: number; second: number; ampm: string; timezone: string },
  ampm: boolean
): string {
  let tmptime = format;
  if (ampm) {
    let hour12 = time.ampm === 'AM' ? time.hour : time.hour % 12;
    hour12 = Number(hour12) === 0 ? 12 : hour12;
    tmptime = tmptime
      .toString()
      .replace(/hh/g, (hour12 < 10 ? '0' : '') + hour12)
      .replace(/h/g, hour12.toString())
      .replace(/min/g, (time.minute < 10 ? '0' : '') + time.minute)
      .replace(/mi/g, time.minute.toString())
      .replace(/ss/g, (time.second < 10 ? '0' : '') + time.second)
      .replace(/s/g, time.second.toString())
      .replace(/TT/g, time.ampm.toUpperCase())
      .replace(/Tt/g, time.ampm.toUpperCase())
      .replace(/tT/g, time.ampm.toLowerCase())
      .replace(/tt/g, time.ampm.toLowerCase())
      .replace(/T/g, time.ampm.charAt(0).toUpperCase())
      .replace(/t/g, time.ampm.charAt(0).toLowerCase())
      .replace(/z/g, time.timezone);
  } else {
    tmptime = tmptime
      .toString()
      .replace(/hh/g, (time.hour < 10 ? '0' : '') + time.hour)
      .replace(/h/g, time.hour.toString())
      .replace(/min/g, (time.minute < 10 ? '0' : '') + time.minute)
      .replace(/mi/g, time.minute.toString())
      .replace(/ss/g, (time.second < 10 ? '0' : '') + time.second)
      .replace(/s/g, time.second.toString())
      .replace(/z/g, time.timezone);
    tmptime = $.trim(tmptime.replace(/t/gi, ''));
  }
  return tmptime;
}
